/**
 * Adjuntos de Entrada
 *
 */
import React from 'react';
import { message, Table, Button, Menu, Dropdown, Popconfirm, Modal, Icon } from 'antd';
import moment from 'moment';
import Cell from '../../../components/Cell';
import Api from '../../../Api';
import Exception from '../../../Exception';

export default class Adjuntos extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.columns = Cell.buildList([
      { title: 'DOCUMENTO', dataIndex: 'documento.sNombre', width: '10%' },
      {
        title: 'NOMBRE', dataIndex: 'dFecha', width: '20%',
        render: (_, record) => <span>
          <a href={Api.to(`/upload/file/${record.iIdArchivo}`)} download={record.archivo.sDescripcion}>
            {record.archivo.sDescripcion}
          </a>
        </span>
      },
      {title: 'ESTADO',dataIndex:'sEstado',width:'15%', render: (estado) => (
        <span style={estado !== 'PENDIENTE' ? { color: estado === 'ACEPTADO' ? 'green' : 'red' } : null}>{estado}</span>
      )},
      {title: 'USUARIO (ACEPTA/RECHAZA)',dataIndex:'usuarioValidacion.sNombre',width:'15%'},
      {title: 'FECHA(ACEPTA/RECHAZO)',width:'10%',dataIndex:'dFechaValidacion',render: val => moment(val).format('YYYY-MM-DD HH:mm:ss')},
      { title: 'FECHA', dataIndex: 'dFecha', width: '25%', render: val => moment(val).format('YYYY-MM-DD HH:mm:ss') },
      {
        title: 'ACCIONES', dataIndex: 'dFecha', width: '15%',
        render: (val, record) => (
          <Popconfirm title='¿Eliminar?' onConfirm={() => this.remove(record)}>
            <Button size='small' icon='delete' />
          </Popconfirm>
        )
      },
    ]);

    this.state = {
      templates: [],
      data: [],
      loading: false,
      entradaId: 0,
    };

    this.requestNewFile = this.requestNewFile.bind(this);
    this.load = this.load.bind(this);
    this.remove = this.remove.bind(this);
  }

  /**
   * Load
   *
   * @param {Number} entradaId
   */
  load(entradaId) {
    this.setState({
      visible: true,
      loading: true,
      templates: [],
      data: [],
      entradaId
    });

    const query = {
      entrada: {
        __returnType: 'one',
        model: 'AlmEntrada', attributes: ['iId'],
        include: [{ as: 'ordenCompra', attributes: ['iId'],
          include: [{ as: 'cuadro', attributes: ['iId'],
            include: [{ as: 'documentos', attributes: ['iId'],
              include: [{ as: 'documento' }]
            }]   
          }]
        }],
        where: {
          iId: entradaId,
        }
      },
      adjuntos: {
        attributes: ['iId', 'dFecha', 'iIdArchivo','sEstado','dFechaValidacion','iIdUsuarioValidacion'],
        model: 'AlmEntradaAdjunto',
        include: [
          { as: 'archivo', attributes: ['sDescripcion'] },
          { as: 'documento', attributes: ['sNombre'] },
          { as: 'usuarioValidacion', attributes:['sNombre']},
        ],
        where: {
          iIdEntrada: entradaId,
          iActivo: true
        }
      }
    };

    Api.query.list(query)
      .then(response =>
        this.setState({
          loading: false,
          templates: response.data.entrada && response.data.entrada.ordenCompra ?
            response.data.entrada.ordenCompra.cuadro.documentos.map(item => item.documento) : [],
          data: response.data.adjuntos,
        })
      )
      .catch(error => {
        this.setState({ loading: false });
        Exception.load(error).show();
      });
  }

  /**
   * Cargar de archivo
   *
   * @param {Object} file
   * @param {Object} doc
   */
  uploadFile(file, doc) {
    this.setState({ loading: true });
    const closeMessage = message.loading('Subiendo', 0);

    // actualizar la ui
    const closeLoadings = () => {
      this.setState({ loading: false });
      closeMessage();
    }

    // invocado al finalizar
    const onFinish = () => {
      closeLoadings();
      message.success('Listo');
      this.load(this.state.entradaId);
    }

    // invocado cuando ocurre algún error
    const onError = error => {
      closeLoadings();
      Exception.load(error).show()
    };

    Api.post('/upload/file', Api.form({ upload: file, tipo: 'WEB.PROVIDER.UPLOAD' }))
      .then(response =>
        Api.post(`/alm/entradas/${this.state.entradaId}/adjuntos`, {
          iIdArchivo: response.data.id,
          iIdDocumento: doc.iId
        })
      )
      .then(onFinish)
      .catch(onError);
  }

  /**
   * Eliminar
   */
  remove(record) {
    this.setState({ loading: true });

    Api.delete(`/alm/entradas/adjuntos/${record.iId}`)
      .then(() => {
        message.success('Eliminado');
        this.setState({
          loading: false,
          data: this.state.data.filter(item => item.iId !== record.iId)
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        Exception.load(error).show();
      });
  }

  /**
   * Solicitar archivo a usuario
   *
   */
  requestNewFile(template) {
    if (!template) {
      return;
    }

    var input = document.createElement('input');
    input.type = 'file';
    input.accept = template.sFiltro;
    input.onchange = e => {
      if (input.files.length > 0) {
        this.uploadFile(input.files[0], template);
      }
      input.value = null;
    };

    input.click();
  }

  /**
   * Render
   *
   */
  render() {
    const { templates } = this.state;
    return (
      <Modal
        title='ADJUNTOS'
        visible={this.state.visible}
        onOk={this.onSave}
        style={{ minWidth: '80%' }}
        onCancel={() => this.setState({ visible: false })}
        footer={[
          <Button
            key='guardar'
            loading={this.state.loading}
            onClick={() => this.setState({ visible: false })}
            children='Cerrar'
          />
        ]}
        children={[
          <div key='1' style={{ marginBottom: 15 }}>
            <Dropdown
              overlay={
                <Menu onClick={e => this.requestNewFile(templates.find(_ => _.iId.toString() === e.key))}>
                  {templates.map(template =>
                    <Menu.Item key={template.iId}>
                      <Icon type='link' style={{ marginRight: 5 }} />
                      <span>{template.sNombre}</span>
                    </Menu.Item>
                  )}
                </Menu>
              }
              children={
                <Button type='primary'>ADJUNTAR</Button>
              }
            />
          </div>,
          <Table
            key='2'
            rowKey='iId'
            size='small'
            loading={this.state.loading}
            columns={this.columns}
            pagination={false}
            dataSource={this.state.data}
            bordered={false}
          />
        ]}
      />
    );
  }
}
